(() => {
  const once = (node, callback) => {
    if (node.dataset.commerceReady) return;
    node.dataset.commerceReady = 'true';
    callback(node);
  };
  function navigation(button) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const setOpen = open => {
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    button.addEventListener('click', () => setOpen(panel.hidden));
    panel.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
    button.closest('header')?.addEventListener('keydown', event => {
      if (event.key === 'Escape') { setOpen(false); button.focus(); }
    });
  }
  function collection(root) {
    const sort = root.querySelector('[data-commerce-sort]');
    sort?.addEventListener('change', () => sort.form.requestSubmit());
    if (root.dataset.complete !== 'true') return;
    const toolbar = root.querySelector('[data-commerce-filters]');
    if (!toolbar) return;
    const cards = [...root.querySelectorAll('[data-coffee-card]')];
    const buttons = [...toolbar.querySelectorAll('[data-flavour-filter]')];
    const count = root.querySelector('[data-result-count]');
    const clear = root.querySelector('[data-clear-filter]');
    const empty = root.querySelector('[data-no-results]');
    function filter(value, updateUrl = true) {
      if (!buttons.some(button => button.dataset.flavourFilter === value)) value = 'all';
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.flavourFilter === value)));
      cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.flavour !== value; });
      const visible = cards.filter(card => !card.hidden).length;
      if (count) count.textContent = `${visible} ${visible === 1 ? 'coffee' : 'coffees'}`;
      if (clear) clear.hidden = value === 'all';
      if (empty) empty.hidden = visible > 0;
      if (sort?.form) {
        let field = sort.form.querySelector('input[name="flavour"]');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'flavour'; sort.form.append(field); }
        field.value = value;
        field.disabled = value === 'all';
      }
      if (updateUrl) {
        const url = new URL(location.href);
        if (value === 'all') url.searchParams.delete('flavour'); else url.searchParams.set('flavour', value);
        history.replaceState(null, '', url);
      }
    }
    toolbar.hidden = false;
    buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.flavourFilter)));
    clear?.addEventListener('click', () => filter('all'));
    filter(new URL(location.href).searchParams.get('flavour') || 'all', false);
    window.addEventListener('popstate', () => filter(new URL(location.href).searchParams.get('flavour') || 'all', false));
  }
  function product(root) {
    const form = root.querySelector('.product-form');
    const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
    const id = form.querySelector('[data-commerce-variant]');
    id.disabled = false;
    const options = [...form.querySelectorAll('[data-commerce-option]')];
    const plan = form.querySelector('[data-commerce-plan]');
    const add = form.querySelector('[data-commerce-add]');
    const sticky = root.querySelector('[data-commerce-sticky-add]');
    const error = form.querySelector('[data-commerce-error]');
    const quantity = form.querySelector('[name="quantity"]');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style:'currency', currency:root.dataset.currency}).format(cents / 100);
    const purchaseOptions = form.querySelector('[data-coffee-purchase-options]');
    const modes = [...form.querySelectorAll('[name="purchase-mode"]')];
    const planOptions = plan ? [...plan.options] : [];
    let preferredPlanName = '';
    let lastVariantId;
    if (purchaseOptions) {
      purchaseOptions.hidden = false;
      const requestedPlan = new URL(location.href).searchParams.get('selling_plan');
      const initialVariant = variants.find(variant => String(variant.id) === id.value);
      const initialPlan = initialVariant?.allocations.find(allocation => String(allocation.id) === requestedPlan && planOptions.some(option => option.value === requestedPlan));
      if (initialPlan) {
        preferredPlanName = initialPlan.name;
        modes.find(input => input.value === 'subscribe').checked = true;
        plan.value = requestedPlan;
      }
    }
    let busy = false;
    function update() {
      const values = options.map(group => group.querySelector('input:checked')?.value);
      const variant = options.length ? variants.find(item => item.options.every((value, index) => value === values[index])) : variants[0];
      if (purchaseOptions) {
        const allocations = (variant?.allocations || []).filter(item => planOptions.some(option => option.value === String(item.id)));
        const subscribing = modes.find(input => input.checked)?.value === 'subscribe';
        let choice = allocations.find(item => String(item.id) === plan.value);
        if (variant?.id !== lastVariantId || !choice) choice = allocations.find(item => item.name === preferredPlanName) || allocations[0];
        if (choice) preferredPlanName = choice.name;
        planOptions.forEach(option => {
          const applicable = allocations.some(item => String(item.id) === option.value);
          option.disabled = !applicable;
          option.hidden = !applicable;
        });
        plan.disabled = !subscribing || !choice;
        plan.value = subscribing && choice ? String(choice.id) : '';
        form.querySelector('[data-coffee-frequency]').hidden = !subscribing || !choice;
        modes.find(input => input.value === 'subscribe').disabled = !choice;
        form.querySelector('[data-coffee-sub-unavailable]').hidden = Boolean(choice);
        form.querySelector('[data-coffee-once-price]').textContent = variant ? money(variant.price) : '';
        form.querySelector('[data-coffee-sub-price]').textContent = choice ? money(choice.price) : 'Unavailable';
        form.querySelector('[data-coffee-saving]').textContent = choice && variant.price ? `${Math.round((variant.price - choice.price) / variant.price * 100)}%` : '';
        const kilo = variant?.options.some(value => /^1\s*kg$/i.test(value));
        form.querySelector('[data-coffee-sub-delivery]').textContent = kilo
          ? 'Free Republic of Ireland delivery on every 1kg subscription delivery. Northern Ireland rates apply.'
          : 'Republic of Ireland delivery: €5, free at €40 after discounts. Each renewal qualifies separately. Northern Ireland rates apply.';
        const defaultDelivery = root.querySelector('[data-commerce-default-delivery]');
        if (defaultDelivery) defaultDelivery.hidden = subscribing;
        lastVariantId = variant?.id;
      }
      const allocation = variant?.allocations.find(item => String(item.id) === plan?.value);
      const subscriptionRequested = purchaseOptions && modes.find(input => input.checked)?.value === 'subscribe';
      const available = Boolean(variant?.available && (!plan?.value || allocation) && (!subscriptionRequested || allocation));
      id.value = variant?.id || '';
      add.disabled = busy || !available;
      sticky.disabled = busy || !available;
      root.querySelector('[data-commerce-add-label]').textContent = busy ? 'Adding...' : available ? 'Add to bag' : variant?.available ? 'Unavailable' : 'Sold out';
      sticky.textContent = busy ? 'Adding...' : available ? 'Add to bag' : 'Unavailable';
      root.querySelector('[data-commerce-stock]').textContent = available ? 'Available' : 'Unavailable';
      const price = variant ? money(allocation?.price ?? variant.price) : '';
      const purchaseLabel = root.querySelector('[data-commerce-purchase-label]');
      if (purchaseLabel) purchaseLabel.textContent = plan?.value ? 'Per delivery' : 'One-time purchase';
      root.querySelectorAll('[data-commerce-price]').forEach(node => { node.textContent = price; });
      root.querySelector('[data-commerce-selection]').textContent = variant ? `${variant.title === 'Default Title' ? '' : variant.title + ' · '}${price}${allocation ? ' / delivery' : ''}` : 'Choose an available option';
      const packNote = root.querySelector('[data-commerce-pack-note]');
      if (packNote) packNote.hidden = !variant?.options.some(value => /[12]\s*kg/i.test(value));
      if (variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        if (purchaseOptions) {
          if (plan.value) url.searchParams.set('selling_plan', plan.value);
          else url.searchParams.delete('selling_plan');
        }
        history.replaceState(null, '', url);
      }
    }
    form.addEventListener('change', () => { update(); form.dispatchEvent(new CustomEvent('commerce:variant-change')); });
    root.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
      quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(button.dataset.quantityChange));
    }));
    sticky.addEventListener('click', () => form.requestSubmit(add));
    const stickyBar = sticky.closest('[data-commerce-sticky]');
    if (stickyBar && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        stickyBar.hidden = entries.some(entry => entry.isIntersecting);
      });
      observer.observe(form.querySelector('.purchase-actions'));
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || add.disabled || !form.reportValidity()) return;
      busy = true;
      error.hidden = true;
      update();
      try {
        const body = new FormData(form);
        body.delete('purchase-mode');
        if (!body.get('selling_plan')) body.delete('selling_plan');
        if (window.CommerceBag) {
          await window.CommerceBag.add(body, add);
          busy = false;
          update();
          return;
        }
        const response = await fetch(root.dataset.addUrl, {method:'POST', body, headers:{Accept:'application/json'}});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
        location.assign(root.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || 'Please check your connection and try again.';
        error.hidden = false;
        busy = false;
        update();
      }
    });
    update();
    form.dispatchEvent(new CustomEvent('commerce:variant-change'));
    const thumbs = [...root.querySelectorAll('[data-photo-index]')];
    const photo = root.querySelector('[data-commerce-photo]');
    let active = Math.max(0, thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    function show(index) {
      if (!thumbs.length || !photo) return;
      active = (index + thumbs.length) % thumbs.length;
      photo.removeAttribute('srcset');
      photo.src = thumbs[active].dataset.photoSrc;
      photo.alt = thumbs[active].dataset.photoAlt;
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      root.querySelector('[data-photo-count]').textContent = `${active + 1} / ${thumbs.length}`;
    }
    thumbs.forEach((button, index) => button.addEventListener('click', () => show(index)));
    root.querySelectorAll('[data-photo-direction]').forEach(button => button.addEventListener('click', () => show(active + Number(button.dataset.photoDirection))));
  }
  function start() {
    document.querySelectorAll('[data-menu-toggle]').forEach(node => once(node, navigation));
    document.querySelectorAll('[data-commerce-collection]').forEach(node => once(node, collection));
    document.querySelectorAll('[data-commerce-product]').forEach(node => once(node, product));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
